import { render, staticRenderFns } from "./app.password.recovery.vue?vue&type=template&id=7a8e6036&"
import script from "./app.password.recovery.vue?vue&type=script&lang=js&"
export * from "./app.password.recovery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports